import type { FormatUserDisplayName } from "./types";

// Mirrors the server's formatUserDisplayName so a name built here matches one loaded later.
export const formatUserDisplayName: FormatUserDisplayName = ({
  firstName,
  lastName,
  email,
}) => {
  const fullName = [firstName, lastName].filter(Boolean).join(" ").trim();
  return fullName || email;
};
